// extracted by mini-css-extract-plugin
export var active = "Navigation-module--active--co6Ka";
export var externalIcon = "Navigation-module--externalIcon--ydoKR";
export var hamburgerBtn = "Navigation-module--hamburgerBtn--Mhhb2";
export var logo = "Navigation-module--logo--N6Ez8";
export var logoLink = "Navigation-module--logoLink--aUVIb";
export var navigation = "Navigation-module--navigation--U0d+O";
export var showHamburger = "Navigation-module--showHamburger--ahe1o";